import { render } from "./MComboButton.vue?vue&type=template&id=1ff8a0b2"
import script from "./MComboButton.vue?vue&type=script&lang=js"
export * from "./MComboButton.vue?vue&type=script&lang=js"

import "./MComboButton.vue?vue&type=style&index=0&id=1ff8a0b2&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__